import React from "react";
import ContentCardSkeleton from "../../contentcards/skeleton/ContentCardSkeleton";
import "../../../stylesheet/components/contentcards/skeleton/CatalogueContainerSkeleton.scss";

const CatalogueContainerSkeleton: React.FC = () => {
  const rows = [];
  for (let i = 0; i < 16; i++) {
    rows.push(<ContentCardSkeleton key={i} />);
  }
  //return tbody(rows);
  return (
    // <tbody className="catalogue-skeleton-grid">{rows}</tbody>
    <div className="catalogue-skeleton-grid">{rows}</div>
  );
};

export default CatalogueContainerSkeleton;
